import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './rsvp-by-host-accepted.scss'
import TotalTicketsCounts from './TotalTicketsCounts'
import Button from '../common/Button'
import TicketCountsSelector from './TicketCountsSelector'
import { pluralize, sumCount } from '../../services/utils'
import RsvpTitle from './RsvpTitle'

const getGuestsDescription = (ticketCounts, child_count_enabled) => {
  const adultTicketCounts = ticketCounts.filter((item) => item.label === 'adult')
  const childTicketCounts = ticketCounts.filter((item) => item.label === 'child')

  const numAdults = sumCount(adultTicketCounts)
  const numChildren = sumCount(childTicketCounts)
  const numTickets = sumCount(ticketCounts)

  let text = ''

  if (!child_count_enabled) {
    text = `${numTickets} ${pluralize(numTickets, 'Guest')}`
    return text
  }

  if (numChildren > 0) {
    text = `${numAdults} Adult, ${numChildren} ${pluralize(numTickets, 'Child Guest')}`
    return text
  }

  return `${numAdults} Adult ${pluralize(numAdults, 'Guest')}`
}

const RSVPByHostAccepted = ({
  event,
  displayName,
  ticketCounts,
  listMyOrdersForEvent,
  onConfirm
}) => {
  const [showChangeRsvp, setShowChangeRsvp] = useState(false)
  const [editTicketCounts, setEditTicketCounts] = useState(ticketCounts)

  const handleChangeCount = (id, count) => {
    const newCounts = editTicketCounts.map(item =>
      item.id === id ? { ...item, count } : item
    )
    setEditTicketCounts(newCounts)
  }

  const handleChangeRsvpClick = () => {
    setShowChangeRsvp(true)
  }

  const handleSaveChanges = () => {
    onConfirm({ rsvpState: 'accepted', ticketCounts: editTicketCounts })
  }

  const handleDecline = () => {
    onConfirm({
      rsvpState: 'declined',
      ticketCounts: editTicketCounts
    })
  }

  const _validConfirm = () => {
    const hasValidCount = editTicketCounts.some(item =>
      (item.label === 'adult' || item.label === 'guest') && item.count > 0
    )

    const isChanged = editTicketCounts.some((item) => {
      const origin = ticketCounts.find(o => o.id === item.id)
      return !origin || origin.count !== item.count
    })

    return !(hasValidCount && isChanged)
  }

  if (!showChangeRsvp) {
    return (
      <div className={styles['container']}>
        <RsvpTitle
          title="Yes, I’m Going"
          subTitle={event?.name}
        />
        <TotalTicketsCounts
          needPayTicket={false}
          ticketCounts={ticketCounts}
          listMyOrdersForEvent={listMyOrdersForEvent}
          childCountEnabled={event.child_count_enabled}
        />
        <Button onClick={handleChangeRsvpClick} className={styles['confirm-button']}>
          change RSVP
        </Button>
      </div>
    )
  }

  return (
    <div className={styles['container']}>
      <RsvpTitle
        title="Change RSVP"
        subTitle={
          <div className={styles['change-rsvp-subtitle']}>
            {`${displayName} is Going`}
          </div>
        }
        description={
          getGuestsDescription(editTicketCounts, event.child_count_enabled)
        }
      />

      {
        event.guest_count_enabled && (
          <>

            <TicketCountsSelector
              child_count_enabled={event.child_count_enabled}
              ticketCounts={editTicketCounts}
              onChangeCount={handleChangeCount}
            />

            <Button
              onClick={handleSaveChanges}
              className={styles['confirm-button']}
              disabled={_validConfirm()}
            >
              save changes
            </Button>
          </>
        )
      }

      <div className={styles['change-rsvp-label']}>
        Change RSVP:{' '}
        <div className={styles['link']} onClick={handleDecline}>
          {displayName ? `${displayName} Can’t Go` : `Can’t Go`}
        </div>
      </div>
    </div>
  )
}

RSVPByHostAccepted.propTypes = {
  event: PropTypes.object,
  displayName: PropTypes.string,
  ticketCounts: PropTypes.array.isRequired,
  listMyOrdersForEvent: PropTypes.array,
  onConfirm: PropTypes.func.isRequired
}

export default RSVPByHostAccepted
